<script lang="ts">
	
	import {onMount, afterUpdate} from "svelte";
    import ServicesIntro from "../components/DomainIntro.svelte";
    import Prestation, { PrestationProps } from "../components/Prestation.svelte";
    import PrestationContact, { PrestationContactProps } from "../components/PrestationContact.svelte";
	import {scrollTo} from "../scripts/commons";
    import {
        idPageAmenagements,
        idPageAmenagementsContact,
        idPageAmenagementsEnrobes,
        idPageAmenagementsPavage,
        idPageAmenagementsResines,
    } from "../scripts/router2";
	import { storeAnchorToLight, storeIsFirstDisplay } from "../scripts/store";

	export let anchor: string = "";

	let imagesMobileEnrobes: string[] = [];
	imagesMobileEnrobes.push("mobile-amenagements/enrobes/prestation-enrobes-1.png");
	imagesMobileEnrobes.push("mobile-amenagements/enrobes/prestation-enrobes-7.jpg");
	imagesMobileEnrobes.push("mobile-amenagements/enrobes/prestation-enrobes-8.jpg");
	imagesMobileEnrobes.push("mobile-amenagements/enrobes/prestation-enrobes-9.jpg");
	imagesMobileEnrobes.push("mobile-amenagements/enrobes/prestation-enrobes-10.jpg");
	imagesMobileEnrobes.push("mobile-amenagements/enrobes/prestation-enrobes-11.jpg");
	imagesMobileEnrobes.push("mobile-amenagements/enrobes/prestation-enrobes-12.jpg");
	imagesMobileEnrobes.push("mobile-amenagements/enrobes/prestation-enrobes-13.jpg");

	let imagesDesktopEnrobes: string[] = [];
	imagesDesktopEnrobes.push("amenagements/enrobes/prestation-enrobes-1.png");
	imagesDesktopEnrobes.push("amenagements/enrobes/prestation-enrobes-7.png");
	imagesDesktopEnrobes.push("amenagements/enrobes/prestation-enrobes-8.png");
	imagesDesktopEnrobes.push("amenagements/enrobes/prestation-enrobes-9.jpg");
	imagesDesktopEnrobes.push("amenagements/enrobes/prestation-enrobes-10.jpg");
	imagesDesktopEnrobes.push("amenagements/enrobes/prestation-enrobes-11.jpg");
	imagesDesktopEnrobes.push("amenagements/enrobes/prestation-enrobes-12.jpg");
	imagesDesktopEnrobes.push("amenagements/enrobes/prestation-enrobes-13.jpg");

	const slash: string = "<span style='color:#FF6A2F; font-weight:700;'>/&nbsp;</span>";
	let prestationTextEnrobes: string = "ATTAL AMENAGEMENT est spécialisé dans la mise en œuvre d’enrobés à chaud depuis de nombreuses années. Ceinturé de bordures ou de chainettes pavés, ce revêtement traditionnel offre un grand confort d'utilisation et d'usage pour un minimum d'entretien. L'enrobé est souvent préféré pour sa résistance aux passages répétés de voitures et autres véhicules. En effet, c'est le revêtement utilisé pour les routes et autoroutes, c'est donc un revêtement stable et très résistant.";

	const prestationEnrobes: PrestationProps = {
		id: "enrobes",
		title: "ENROBÉS",
		text: prestationTextEnrobes,
		imagesMobile: imagesMobileEnrobes,
		imagesDesktop: imagesDesktopEnrobes
	}

	let imagesMobileResines: string[] = [];
	imagesMobileResines.push("mobile-amenagements/resines/prestation-resines-4.jpg");
	imagesMobileResines.push("mobile-amenagements/resines/prestation-resines-8.jpg");
	imagesMobileResines.push("mobile-amenagements/resines/prestation-resines-12.jpg");
	imagesMobileResines.push("mobile-amenagements/resines/prestation-resines-14.jpg");
	imagesMobileResines.push("amenagements/resines/prestation-resines-15.jpg");
	imagesMobileResines.push("amenagements/resines/prestation-resines-16.jpg");
	imagesMobileResines.push("amenagements/resines/prestation-resines-17.jpg");
	imagesMobileResines.push("amenagements/resines/prestation-resines-18.jpg");

	let imagesDesktopResines: string[] = [];
	imagesDesktopResines.push("amenagements/resines/prestation-resines-4.png");
	imagesDesktopResines.push("amenagements/resines/prestation-resines-8.jpg");
	imagesDesktopResines.push("amenagements/resines/prestation-resines-12.jpg");
	imagesDesktopResines.push("amenagements/resines/prestation-resines-14.jpg");
	imagesDesktopResines.push("amenagements/resines/prestation-resines-15.jpg");
	imagesDesktopResines.push("amenagements/resines/prestation-resines-16.jpg");
	imagesDesktopResines.push("amenagements/resines/prestation-resines-17.jpg");
	imagesDesktopResines.push("amenagements/resines/prestation-resines-18.jpg");

	let prestationTextResines: string = "Applicateur agréé des produits Résinéo.<br>";
	prestationTextResines = prestationTextResines + "ATTAL AMÉNAGEMENT propose des revêtements drainants, fabriqués à partir de résines et de granulats minéraux aux teintes naturelles (sans colorant). S’inscrivant dans une démarche durable qui favorise la perméabilité des sols et limite les îlots de chaleur. La résine drainante est la solution idéale pour sublimer les espaces extérieurs tels que les plages de piscine, terrasses et allées de jardin.";

	const prestationResines: PrestationProps = {
		id: "resines",
		title: "RÉSINES DRAINANTES",
		text: prestationTextResines,
		imagesMobile: imagesMobileResines,
		imagesDesktop: imagesDesktopResines
	}

	let imagesMobilePavage: string[] = [];
	imagesMobilePavage.push("mobile-amenagements/pavage/prestation-pavage-1.jpg");
	imagesMobilePavage.push("mobile-amenagements/pavage/prestation-pavage-2.jpg");
	imagesMobilePavage.push("mobile-amenagements/pavage/prestation-pavage-3.jpg");
	imagesMobilePavage.push("mobile-amenagements/pavage/prestation-pavage-4.jpg");
	imagesMobilePavage.push("mobile-amenagements/pavage/prestation-pavage-6.jpg");
	imagesMobilePavage.push("amenagements/pavage/prestation-pavage-7.jpg");
	imagesMobilePavage.push("amenagements/pavage/prestation-pavage-8.jpg");
	imagesMobilePavage.push("amenagements/pavage/prestation-pavage-9.jpg");
	imagesMobilePavage.push("amenagements/pavage/prestation-pavage-10.jpg");

	let imagesDesktopPavage: string[] = [];
	imagesDesktopPavage.push("amenagements/pavage/prestation-pavage-1.png");
	imagesDesktopPavage.push("amenagements/pavage/prestation-pavage-2.png");
	imagesDesktopPavage.push("amenagements/pavage/prestation-pavage-3.jpg");
	imagesDesktopPavage.push("amenagements/pavage/prestation-pavage-4.png");
	imagesDesktopPavage.push("amenagements/pavage/prestation-pavage-6.png");
	imagesDesktopPavage.push("amenagements/pavage/prestation-pavage-7.jpg");
	imagesDesktopPavage.push("amenagements/pavage/prestation-pavage-8.jpg");
	imagesDesktopPavage.push("amenagements/pavage/prestation-pavage-9.jpg");
	imagesDesktopPavage.push("amenagements/pavage/prestation-pavage-10.jpg");

	let prestationTextPavage: string = "Nos équipes vous proposent différents revêtements de sol comme le pavage ou la mise en place de gravillons déco. Le choix dans les coloris de graviers et de pavés permet d’assortir la surface à l’architecture de la maison.<br>";
	prestationTextPavage = prestationTextPavage + "Pour renforcer le maintien des gravillons décoratifs et éviter la pousse de mauvaises herbes nous pouvons appliquer les gravillons dans un stabilisateur « Eccogravel ».";

	const prestationPavage: PrestationProps = {
		id: "pavage",
		title: "PAVAGES ET GRAVILLONS",
		text: prestationTextPavage,
		imagesMobile: imagesMobilePavage,
		imagesDesktop: imagesDesktopPavage
	}

	let prestationTextContact: string = "208 Saint Jacques<br>";
	prestationTextContact = prestationTextContact + "44850 St Mars Du Désert<br>";
	prestationTextContact = prestationTextContact + slash;
	prestationTextContact = prestationTextContact + "T. 02 72 17 79 73<br>";
	prestationTextContact = prestationTextContact + slash;
	prestationTextContact = prestationTextContact + "<a href='mailto:amenagements@attalservices.fr' target='_blank' style='color:#FFFFFF; text-decoration:none;'>amenagements@attalservices.fr</a>";
	const prestationContact: PrestationContactProps = {
		id: "amenagements-contact",
		title: "ATTAL SERVICES",
		text: prestationTextContact,
	}

	let anchorPositionEnrobes: number = 0;
	let anchorPositionResines: number = 0;
	let anchorPositionPavage: number = 0;
	let anchorPositionContact: number = 0;

	afterUpdate(() => {
		anchorPositionEnrobes = document.getElementById(idPageAmenagementsEnrobes).getBoundingClientRect().top;
		anchorPositionResines = document.getElementById(idPageAmenagementsResines).getBoundingClientRect().top;
		anchorPositionPavage = document.getElementById(idPageAmenagementsPavage).getBoundingClientRect().top;
		anchorPositionContact = document.getElementById(idPageAmenagementsContact).getBoundingClientRect().top;
	})

	onMount(async () => {
		scrollTo(anchor);
	});

    /**
     * scrollInPage
     */
     function scrollInPage() {
        let currentTop = window.scrollY;
		currentTop = currentTop + 75;
        if (currentTop < anchorPositionEnrobes) {
			storeAnchorToLight.set("");
        }
        if (currentTop > anchorPositionEnrobes && currentTop < anchorPositionResines) {
			storeAnchorToLight.set(idPageAmenagementsEnrobes);
        }
        if (currentTop > anchorPositionResines && currentTop < anchorPositionPavage) {
			storeAnchorToLight.set(idPageAmenagementsResines);
        }
        if (currentTop > anchorPositionPavage && currentTop < anchorPositionContact) {
			storeAnchorToLight.set(idPageAmenagementsPavage);
        }
        if (currentTop > anchorPositionContact) {
			storeAnchorToLight.set(idPageAmenagementsContact);
        }
    }

</script>

<svelte:window on:scroll={scrollInPage} />
{#if $storeIsFirstDisplay}
<div class="fonduintro">
</div>
{:else}
<div class="fondudomaine">
</div>
{/if}
<div class="amenagements__anchor" id={idPageAmenagements}></div>
<div class="amenagements">
	<h1 class="amenagements__hi">Attal Aménagements</h1>
	<ServicesIntro />
	<div class="amenagements__anchor" id={idPageAmenagementsEnrobes}></div>
	<h2 class="amenagements__hi">{prestationEnrobes.title}</h2>
	<h3 class="amenagements__hi">Terrasse&nbsp;Aménagement extérieur, particulier, paysage</h3>
	<Prestation props={prestationEnrobes}/>
	<div class="amenagements__anchor" id={idPageAmenagementsResines}></div>
	<h2 class="amenagements__hi">{prestationResines.title}</h2>
	<h3 class="amenagements__hi">Goudron&nbsp;Bitume&nbsp;Revêtement</h3>
	<Prestation props={prestationResines}/>
	<div class="amenagements__anchor" id={idPageAmenagementsPavage}></div>
	<h2 class="amenagements__hi">{prestationPavage.title}</h2>
	<h3 class="amenagements__hi">Pose pavés&nbsp;Allée de jardin&nbsp;Cours</h3>
	<Prestation props={prestationPavage}/>
	<div class="amenagements__anchor" id={idPageAmenagementsContact}></div>
	<div class="amenagements__contact">
		<h2 class="amenagements__hi">{prestationContact.title}</h2>
		<h3 class="amenagements__hi">Paysagiste&nbsp;Travaux publics</h3>
		<PrestationContact props={prestationContact}/>
	</div>
</div>	

<style lang="scss">
	
	:global(body) {
		padding: 0;
		margin: 0;
		min-height: 100%;
		height: 100%;
		background-color: $color-bordeau-instit;
		color: $color-white;
	}

	.fonduintro {
		z-index: 10000000;
		position: absolute;
		top: 0;
		width: 100%;
		height: 200%;
		animation-fill-mode: forwards;
		animation-name: firstfadeout;
		background-color: $color-bordeau-instit;
		animation-duration: 1s;
	}

	.fondudomaine {
		z-index: 10;
		position: absolute;
		width: 100%;
		height: 200%;
		animation-fill-mode: forwards;
		animation-name: fadeout;
		background-color: $color-bleu-instit;
		animation-duration: 1.5s;
	}

	.amenagements {
		display: grid;
		grid-template-columns: 1fr;
		padding: calc($header-height + 15px) 0 0 0;
		&__hi {
			display: none;
		}
		&__anchor {
			scroll-margin-top: calc($header-height + 15px);
		}
		&__contact {
			min-height: 100vh;
		}
	}

	@include large {
	}

    @keyframes fadeout {
        0% {opacity: 1; height: 200%;}
		75% {opacity: 1; height: 200%;}
		99% {height: 200%;}
        100% {opacity: 0; height: 0;}
    }

	@keyframes firstfadeout {
        0% {opacity: 1; height: 200%;}
		99% {height: 200%;}
        100% {opacity: 0; height: 0;}
    }

</style>